<template>
  <div
    id="branding-templates"
  >
    <h2>
      Templates
    </h2>

    <branding-nav />

    <pagination
      :resourceUrl="resourceUrl"
      orderBy="created_at"
      orderType="DESC"
      ref="pagination"
      attrIncludes
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <router-link
          :to="{
            name: 'branding_template',
            params: {
              brandingTemplateId: item.id
            }
          }"
          class="list-group-item list-group-item-action"
        >
          {{ item.name }}
          <span
            class="badge badge-secondary"
            v-if="item.inactive"
          >
            Inactive
          </span>
        </router-link>
      </template>
    </pagination>

    <router-link
      :to="{
        name: 'create_branding_template'
      }"
      tag="button"
      class="btn btn-primary btn-block"
    >
      Create Template
    </router-link>
  </div>
</template>
<script>
import BrandingNav from '@/components/BrandingNav'

import Pagination from 'sai-vue-kaminari'

export default {
  computed: {
    resourceUrl () {
      return this.apiUrl('/branding_templates', true)
    }
  },

  components: {
    'branding-nav': BrandingNav,
    'pagination': Pagination
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BrandingTemplates.vue